/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChannelNotificationIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABFUlEQVR4nO2VS07DQAyGhw2rbkDiHmWJuACQjH+DZOz0OtAqXIeuS7kMZM1j3aIJpUIN1UySrlBH8mpG/vz4x3bu3xwROSTWBw99JbZlF/OsL8RWBl8NQLjo6piaVjYAfSKnTYNVf2Ww3KW5PYD2JaJ+KlrsRkWwiqATIju9EDkRkYG/uT0Hiqv+ANhURI6TZ1HLmfPonDuoJwArCPpMrJ/BPNscKHx3AKzKstFRwvwadwJ42P068nimeWsAMBrW7+uyxAD21Bogq8Z62EcC4H0NWC2LFMAgFUCsb60XTs7F2XdANo8LQmcbK9PKSCaLnPUyvA9SjAKuLUv+J1v+zni72vSul/OfE6QY1BJ6UvcFOvsd+RdzZgpjLhC6oQAAAABJRU5ErkJggg==)
 */
export const ChannelNotificationIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v6.88c0 .37-.38.61-.73.5a7 7 0 0 0-8.9 8.89c.12.35-.12.73-.49.73H5a3 3 0 0 1-3-3V5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
        className={colorClass}
      />
    </svg>
  );
};
